"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncSelect = exports.AsyncSelectElement = void 0;
const react_1 = __importStar(require("react"));
const async_1 = __importDefault(require("react-select/async"));
const formik_1 = require("formik");
const axios_1 = __importDefault(require("axios"));
const react_i18next_1 = require("react-i18next");
const BaseInput_1 = require("../BaseInput/BaseInput");
const defaultProps = {
    mapValue: 'id',
    queryFormat: 'mongodb',
    mapLabel: 'name',
};
exports.AsyncSelectElement = (props) => {
    const { field } = props;
    const [isUnmounted] = react_1.useState(false);
    const [isLoading, setIsLoading] = react_1.useState(true);
    const [defaultValue, setDefaultValue] = react_1.useState(undefined);
    const setupDefaultValue = () => {
        const { getUrl, mapValue, mapLabel } = props;
        const mapV = mapValue || defaultProps.mapValue;
        const mapL = mapLabel || defaultProps.mapLabel;
        return axios_1.default.get(getUrl, { params: { filter: { where: { [mapV]: field.value } } } }).then((r) => {
            if (!isUnmounted) {
                setDefaultValue({
                    value: r.data[0][mapV],
                    label: r.data[0][mapL],
                });
                setIsLoading(false);
            }
        });
    };
    react_1.useEffect(() => {
        if (field.value)
            setupDefaultValue();
        else
            setIsLoading(false);
        // eslint-disable-next-line
    }, []);
    const onChange = (o) => {
        const { form } = props;
        form.setFieldValue(field.name, o === null ? '' : o.value);
    };
    const buildQuery = (inputValue) => {
        const { searchFields, queryFormat, query } = props;
        const qf = queryFormat || defaultProps.queryFormat;
        let inputQuery;
        if (qf === 'postgresql') {
            inputQuery = { ilike: `%${inputValue}%` };
        }
        else {
            inputQuery = { like: inputValue, options: 'i' };
        }
        if (query) {
            inputQuery = { and: [query, { [searchFields[0]]: inputQuery }] };
        }
        else {
            inputQuery = { [searchFields[0]]: inputQuery };
        }
        return inputQuery;
    };
    const loadOptions = (inputValue) => {
        const { getUrl, mapValue, mapLabel, onError, order } = props;
        const mapV = mapValue || defaultProps.mapValue;
        const mapL = mapLabel || defaultProps.mapLabel;
        return new Promise((resolve, reject) => {
            axios_1.default.get(getUrl, {
                params: { filter: { where: buildQuery(inputValue), order }, limit: 10 },
            })
                .then((r) => resolve(r.data.map((c) => ({ value: c[mapV], label: c[mapL] }))))
                .catch((e) => {
                if (onError)
                    onError(e);
                reject(e);
            });
        });
    };
    const { form, className } = props;
    const { t } = react_i18next_1.useTranslation('AsyncSelect');
    if (isLoading)
        return react_1.default.createElement("p", null, t('loading'));
    return (
    // eslint-disable-next-line
    react_1.default.createElement(BaseInput_1.BaseInput, Object.assign({}, props, { name: props.field.name }), ({ getInvalidClass, getErrorMessageField, getId, getPlaceholder }) => (react_1.default.createElement("div", { className: "ReactSelectHelper" },
        react_1.default.createElement(async_1.default, { cacheOptions: true, placeholder: getPlaceholder(), className: `${className || ''} ${getInvalidClass(props)}`, id: getId(), classNamePrefix: "AsynSelect", defaultOptions: true, isClearable: true, onBlur: () => form.setFieldTouched(field.name, true), loadOptions: loadOptions, onChange: onChange, defaultValue: defaultValue }),
        getErrorMessageField()))));
};
exports.AsyncSelect = (props) => (
// eslint-disable-next-line
react_1.default.createElement(formik_1.Field, Object.assign({ component: exports.AsyncSelectElement }, props)));
//# sourceMappingURL=AsyncSelect.js.map